import request from '../../../helpers/request';

const changeFlatMeter = async (meterId, values) => {
  const response = await request.put(
    `/Meter/individual_meter/${meterId}`,
    values,
    `При изменении данных счетчика произошла ошибка`,
    'Error'
  );

  return response;
};

export default changeFlatMeter;
